/**
 * 监听内容滚动到底部，常用于下拉加载
 * @date 2020-07-24
 * @author Kody
 */
import { useRef } from 'react';
import { useScrollEnd } from './useScrollEnd';

export const useScrollBottom = (
    callback: () => void,
    bottomDistance: number = 150, // 距离底部小于此值时，触发回调
    depend: any = [],
    deepFnc?: () => boolean, // 节流函数，return false 时不触发回调
    rootElement?: HTMLElement | string, // 滚动容器。默认为 body
    hasMore: boolean = true
) => {
    const cb = useRef(callback);
    cb.current = callback;
    useScrollEnd(onScroll, depend, rootElement);

    function onScroll(_direction: number, container: Element) {
        if (deepFnc && !deepFnc()) {
            return;
        }
        if (!hasMore) {
            return;
        }
        const scrollTop = container.scrollTop || 0;
        if (container.scrollHeight - ((container as HTMLElement).offsetHeight + scrollTop) < bottomDistance) {
            cb.current();
        }
    }
};
